<script lang='ts'>
  import { cn } from "@/lib/utils";
  import { formatXSSDetails, XSSDeviationCategory, type XSSDetails, type XSSDeviationDetails } from "@/Util/utils";

  export let xssDetails: XSSDetails<number>;
  export let title: string;
  export let xssDeviationCategory: XSSDetails<XSSDeviationDetails> | null = null;
  export let includeRowNames: boolean;

  $: formattedXSS = formatXSSDetails(xssDetails);

</script>

<div class='grid grid-rows-5 grid-flow-col items-center'>
  <h5 class="col-span-2 text-start m-0 font-bold">{title}</h5>

  {#if includeRowNames}
    <div>Peak</div>
    <div>High</div>
    <div>Low</div>
    <div>Total</div>
  {/if}

  <div class='font-bold text-right text-[var(--color-xpss)]'>{formattedXSS.xpss}</div>
  <div class='font-bold text-right text-[var(--color-xhss)]'>{formattedXSS.xhss}</div>
  <div class='font-bold text-right text-[var(--color-xlss)]'>{formattedXSS.xlss}</div>
  <div class='font-bold text-right'>{formattedXSS.xss}</div>

  {#if xssDeviationCategory}
    <i class={cn('fa-solid text-right',
      xssDeviationCategory.xpss.suitability === XSSDeviationCategory.Good ? 'text-[var(--color-xss-deviation-good)] fa-badge-check' :
      xssDeviationCategory.xpss.suitability === XSSDeviationCategory.Warn ? 'text-[var(--color-xss-deviation-warn)] fa-circle-exclamation' :
      'text-[var(--color-xss-deviation-alert)] fa-circle-xmark'
    )} />
    <i class={cn('fa-solid text-right',
      xssDeviationCategory.xhss.suitability === XSSDeviationCategory.Good ? 'text-[var(--color-xss-deviation-good)] fa-badge-check' :
      xssDeviationCategory.xhss.suitability === XSSDeviationCategory.Warn ? 'text-[var(--color-xss-deviation-warn)] fa-circle-exclamation' :
      'text-[var(--color-xss-deviation-alert)] fa-circle-xmark'
    )} />
    <i class={cn('fa-solid text-right',
      xssDeviationCategory.xlss.suitability === XSSDeviationCategory.Good ? 'text-[var(--color-xss-deviation-good)] fa-badge-check' :
      xssDeviationCategory.xlss.suitability === XSSDeviationCategory.Warn ? 'text-[var(--color-xss-deviation-warn)] fa-circle-exclamation' :
      'text-[var(--color-xss-deviation-alert)] fa-circle-xmark'
    )} />
    <!-- <i class={cn('fa-solid text-right',
      xssDeviationCategory.xss.suitability === XSSDeviationCategory.Good ? 'text-[var(--color-xss-deviation-good)] fa-badge-check' :
      xssDeviationCategory.xss.suitability === XSSDeviationCategory.Warn ? 'text-[var(--color-xss-deviation-warn)] fa-circle-exclamation' :
      'text-[var(--color-xss-deviation-alert)] fa-circle-xmark'
    )} /> -->
  {/if}
</div>
